<template>
  <div class="setName-wrap">
    <van-field
      v-model="text"
      class="name-input"
      maxlength="10"
    />
    <div
      class="safe-btn"
      :class="{active:text}"
      @click="safeName"
    >保存</div>
    <DownApp></DownApp>
  </div>
</template>
<script>
import DownApp from "../../components/downApp/downApp";
import axios from "../../http";
import { mapState, mapMutations } from "vuex";

export default {
  name: "set-name",
  components: {
    DownApp
  },
  props: {},
  data() {
    return {
      text: this.$route.query.name
    };
  },
  computed: {
    ...mapState(["token"])
  },
  watch: {},
  mounted() {},
  destroyed() {},
  methods: {
    ...mapMutations(["getUserName"]),
    safeName() {
      //保存名字
      if (this.text == "") {
        //名字为空
        this.$toast("请输入名字");
        return;
      }
      //发送请求
      axios
        .fetchPost("/member/center/info", {
          token: this.token,
          nickname: this.text
        })
        .then(res => {
          let data = res.data;
          if (data.code == 200) {
            this.$toast(data.msg);
            this.getUserName(data.data.nickname);
            setTimeout(() => {
              this.$router.push({
                path: "/secondBar/me"
              });
            }, 500);
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
<style lang="stylus" scoped>
.setName-wrap
  padding-top 10px
.safe-btn
  width 66%
  margin 50px auto
  background rgba(179, 179, 179, 1)
  border-radius 40px
  height 40px
  line-height 40px
  font-size 17px
  font-family Microsoft YaHei
  font-weight 400
  color rgba(255, 255, 255, 1)
  &.active
    background #FF9922
    color #fff
</style>